<template>
  <div>
    <ParseForm :formParams='formParams' :emit='emit' formId='voiceBusiness' :opCode='opCode' ref='bus' :funcClick='bindClickInterface'></ParseForm>
    <CustomDialog ref='userTableLayerDialog' :element='dialog.element.eleUserTable' :styles='dialog.styles' :messages='dialog.messages'>
      <template v-slot:dialog-content>
        <UserTableLayer ref="userTableLayer"></UserTableLayer>
      </template>
    </CustomDialog>
    <CustomDialog ref='groupTableLayerDialog' :element='dialog.element.eleGroupTable' :styles='dialog.styles' :messages='dialog.messagesGroup'>
      <template v-slot:dialog-content>
        <GroupTableLayer ref="groupTableLayer"></GroupTableLayer>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import ParseForm from '../../../subscriberconfig/util/parseFormNew/ParseForm';
import CustomDialog from '../../../common/CustomDialog';
import UserTableLayer from './dialog/userTableLayer';
import GroupTableLayer from './dialog/groupTableLayer';
import bus from './bus';
import commonJS from '../common';


export default {
  name: 'U_VoiceBusiness',
  components: {
    ParseForm,
    CustomDialog,
    UserTableLayer,
    GroupTableLayer
  },
  props: [
    'formParams',
    'reMountPage',
    'info',
    'gmsInfo',
    'opCode',
  ],
  mixins: [commonJS],
  data() {
    return {
      dialog: {
        element: {
          eleUserTable: {
            target: this.$refs.userTableLayer,
            refName: 'eleUserTable',
            buttonGroup: [
              { click: this.clearData, buttonModel: { content: this.$t('ej2Components.uploader.Clear') } },
              { click: this.saveData, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.userInfo'),
            isClose: true
          },
          eleGroupTable: {
            target: this.$refs.groupTableLayer,
            refName: 'eleGroupTable',
            buttonGroup: [
              { click: this.clearGroupData, buttonModel: { content: this.$t('ej2Components.uploader.Clear') } },
              { click: this.saveGroupData, buttonModel: { content: this.$t('MCS.confirm'), isPrimary: true } }
            ],
            title: this.$t('MCS.groupInfo'),
            isClose: true
          },
        },
        styles: {
          width: '700px',
          height: '500px',
          visible: false,
          model: true,
          zIndex: 1001
        },
        messages: this.$t('MCS.userInfo'),
        messagesGroup: this.$t('MCS.groupInfo')
      },
      dialogParamName: '',
      funcMap: ''
    };
  },
  methods: {
    getDatas() {
      return this.$refs.bus.getDatas();
    },
    validateResult() {
      return this.$refs.bus.validateResult();
    },
    emit(attr) {
      bus.$emit('eventBus', attr);
    },
    reMount() {
      this.$refs.bus.reMount();
      this.bindClickInterface();
    },
    saveData() {
      const $this = this;
      switch (this.dialogParamName) {
        case 'commforwardUncond':
          if (this.$refs.userTableLayer.getClickData() !== undefined && this.$refs.userTableLayer.getClickData().participantType === 5) {
            this.$toast('warning', this.$t('MCS.dcWarn'));
            return;
          }
          break;
        case 'commforwardNotReply':
          if (this.$refs.userTableLayer.getClickData() !== undefined && this.$refs.userTableLayer.getClickData().participantType === 5) {
            this.$toast('warning', this.$t('MCS.dcWarn'));
            return;
          }
          break;
        case 'commforwardOnbusy':
          if (this.$refs.userTableLayer.getClickData() !== undefined && this.$refs.userTableLayer.getClickData().participantType === 5) {
            this.$toast('warning', this.$t('MCS.dcWarn'));
            return;
          }
          break;
        case 'commforwardNotLogIn':
          if (this.$refs.userTableLayer.getClickData() !== undefined && this.$refs.userTableLayer.getClickData().participantType === 5) {
            this.$toast('warning', this.$t('MCS.dcWarn'));
            return;
          }
          break;
        case 'commforwardNotReach':
          if (this.$refs.userTableLayer.getClickData() !== undefined && this.$refs.userTableLayer.getClickData().participantType === 5) {
            this.$toast('warning', this.$t('MCS.dcWarn'));
            return;
          }
          break;
        default:
      }
      this.$refs.bus.setData(this.dialogParamName, this.$refs.userTableLayer.getClickData() === undefined ? '' : this.$refs.userTableLayer.getClickData().userNum);
      this.closeTablePage();
    },
    clearData(){
      this.$refs.bus.setData(this.dialogParamName, '');
      this.closeTablePage();
    },
    closeTablePage() {
      this.$refs.userTableLayerDialog.clear();
      this.$refs.userTableLayerDialog.close();
    },
    saveGroupData() {
      this.$refs.bus.setData(this.dialogParamName, this.$refs.groupTableLayer.getClickData() === undefined ? '' : this.$refs.groupTableLayer.getClickData().groupId);
      this.closeGroupTablePage();
    },
    clearGroupData(){
      console.log("clearGroupData");
      this.$refs.bus.setData(this.dialogParamName, '');
      this.closeGroupTablePage();
    },
    closeGroupTablePage() {
      this.$refs.groupTableLayerDialog.clear();
      this.$refs.groupTableLayerDialog.close();
    },
    $bindEmergentNum(key) {
      this.funcMap.set(key, () => {
        const grpNum = this.$refs.bus.getDatas().get('mcpttEmerGrpNum');
        if (key === 'mcpttEmerPrivNum' && grpNum !== null && grpNum !== '' && grpNum !== undefined) {
          this.$toast('warning', this.$t('MCS.emerGrpOrEmerUsr'));
          return;
        }

        this.$refs.userTableLayer.getGridData(this.info);
        this.$refs.userTableLayerDialog.show();
        this.dialogParamName = key;
      });
    },
    $bindEmergentGroupNum(key) {
      this.funcMap.set(key, () => {
        const usrNum = this.$refs.bus.getDatas().get('mcpttEmerPrivNum');
        if (key === 'mcpttEmerGrpNum' && usrNum !== null && usrNum !== '' && usrNum !== undefined) {
          this.$toast('warning', this.$t('MCS.emerGrpOrEmerUsr'));
          return;
        }
        this.$refs.groupTableLayer.getGridData(this.gmsInfo);
        this.$refs.groupTableLayerDialog.show();
        this.dialogParamName = key;
      });
    },
    $bindSwitchFunc(key) {
      const _resMap = new Map();
      switch (key) {
        case 'mcpttCallPermission': {
          _resMap.set(4, this.$checkBoxBitFunc('mcpttEmerGrpNum'));
          _resMap.set(5, this.$checkBoxBitFunc('mcpttEmerPrivNum'));
          _resMap.set(19, this.$checkBoxBitFunc('commforwardUncond'));
          _resMap.set(20, this.$checkBoxBitFunc('commforwardNotReply'));
          _resMap.set(21, this.$checkBoxBitFunc('commforwardOnbusy'));
          _resMap.set(22, this.$checkBoxBitFunc('commforwardNotLogIn'));
          _resMap.set(23, this.$checkBoxBitFunc('commforwardNotReach'));
          break;
        }
        default:
      };
      this.funcMap.set(key, _resMap);
    },
    $checkBoxBitFunc(...paramName) {
      const _resArr = [];
      const $this = this;
      if (paramName.length === 0) return;
      _resArr[0] = () => {
        paramName.forEach((item) => {
          $this.$refs.bus.setAttrByName(item, 'disabled', true);
          $this.$refs.bus.setAttrByName(item, 'readonly', false);
          $this.$refs.bus.setReadonlyNoGray(item);
        });
      };
      _resArr[1] = () => {
        paramName.forEach((item) => {
          $this.$refs.bus.setAttrByName(item, 'disabled', false);
          $this.$refs.bus.setAttrByName(item, 'readonly', true);
          $this.$refs.bus.setReadonlyNoGray(item);
        });
      };
      return _resArr;
    }
  },
  computed: {
    bindClickInterface() {
      this.funcMap = new Map();
      this.$bindEmergentNum('mcpttEmerPrivNum');
      this.$bindEmergentGroupNum('mcpttEmerGrpNum');
      this.$bindEmergentNum('commforwardUncond');
      this.$bindEmergentNum('commforwardNotReply');
      this.$bindEmergentNum('commforwardOnbusy');
      this.$bindEmergentNum('commforwardNotLogIn');
      this.$bindEmergentNum('commforwardNotReach');
      this.$bindSwitchFunc('mcpttCallPermission');
      return this.funcMap;
    },
  },
  mounted() {
    bus.$on('eventBus', (attr) => {
      if (this.$refs.bus === undefined || this.$refs.bus.templetCover === undefined) return;
      this.$refs.bus.templetCover(attr);
    });
  }
};
</script>

<style scoped>

</style>
